module.exports = __webpack_public_path__ + "img/02-1.ceac3747.png";